import { ImageComponent, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";
import type { AddressInputProps } from "../../types";
import {
  AddressInputContainer,
  AddressInputLabel,
  AddressInputStyle,
  AddressInputWrap,
  CloseButton,
} from "./AddressInput.style";

const AddressInput = React.forwardRef<HTMLInputElement, AddressInputProps>(
  (
    {
      placeholderTxt,
      labelTxt,
      margin,
      errorState,
      inputValue,
      handleChange,
      requiredField,
      handleKeyDown,
      maxInputLength,
      inputType,
      handleFocus,
      handleBlur,
      autoComplete = "on",
      isDisabled,
      hasError = false,
      onClear,
      alwaysShowClearButton = false,
    },
    ref
  ) => {
    const handleMouseWheel = (event: any) => {
      event.preventDefault();
    };

    const showClearButton = Boolean(
      (alwaysShowClearButton || Boolean(inputValue)) && !isDisabled && onClear
    );

    return (
      <AddressInputWrap margin={margin}>
        {labelTxt && (
          <AddressInputLabel>
            {labelTxt}
            {requiredField && (
              <SpanTag fontWeight="bold" color={theme.redText2}>
                *
              </SpanTag>
            )}
          </AddressInputLabel>
        )}
        <AddressInputContainer>
          <AddressInputStyle
            ref={ref}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            value={inputValue}
            hasError={hasError}
            placeholder={placeholderTxt}
            maxLength={maxInputLength}
            type={inputType || "text"}
            onWheel={handleMouseWheel}
            autoComplete={autoComplete}
            disabled={isDisabled}
            hasClearButton={showClearButton}
          />
          {showClearButton && (
            <CloseButton
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (handleChange) {
                  const syntheticEvent = {
                    target: { value: "" },
                  } as React.ChangeEvent<HTMLInputElement>;
                  handleChange(syntheticEvent);
                }
                if (onClear) {
                  onClear();
                }
              }}
              aria-label="Clear address"
            >
              <ImageComponent
                width="20px"
                height="20px"
                src="https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
              />
            </CloseButton>
          )}
        </AddressInputContainer>
      </AddressInputWrap>
    );
  }
);

AddressInput.displayName = "AddressInput";

export default AddressInput;
